import React, {
  createContext,
  FC,
  PropsWithChildren,
  useContext,
  useMemo,
} from "react";

interface AuthContextProps {
  authState: any;
}

const AuthContext = createContext<AuthContextProps>({ authState: {} });

export const AuthContextProvider: FC<PropsWithChildren<AuthContextProps>> = ({
  authState,
  children,
}) => {
  const state = useMemo(() => authState, [authState]);
  return (
    <AuthContext.Provider value={{ authState: state }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuthContext = () => {
  const context = useContext(AuthContext);
  if (context === undefined) {
    throw new Error("useAuthContext must be used within a AuthContextProvider");
  }
  return context;
};
